webpackJsonp([26],{

/***/ 1124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompetitorsList_vue__ = __webpack_require__(1285);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdbfb0b2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompetitorsList_vue__ = __webpack_require__(1460);
function injectStyle (ssrContext) {
  __webpack_require__(1456)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bdbfb0b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompetitorsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdbfb0b2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompetitorsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppButton__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FormFields_FSearchSelect__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Pagination__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__composables_competitors_useCompetitorsList__ = __webpack_require__(1458);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'CompetitorsList',
  components: {
    TabLayout: __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__["a" /* default */],
    PageHeading: __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__["a" /* default */],
    AppButton: __WEBPACK_IMPORTED_MODULE_3__components_AppButton__["a" /* default */],
    FSearchSelect: __WEBPACK_IMPORTED_MODULE_4__components_FormFields_FSearchSelect__["a" /* default */],
    Pagination: __WEBPACK_IMPORTED_MODULE_5__components_Pagination__["a" /* default */]
  },
  setup: function setup() {
    var _useCompetitorsList = Object(__WEBPACK_IMPORTED_MODULE_6__composables_competitors_useCompetitorsList__["a" /* default */])(),
        competitors = _useCompetitorsList.competitors,
        meta = _useCompetitorsList.meta,
        filters = _useCompetitorsList.filters,
        filterOptions = _useCompetitorsList.filterOptions,
        filterLoading = _useCompetitorsList.filterLoading,
        filterLoadingMore = _useCompetitorsList.filterLoadingMore,
        loading = _useCompetitorsList.loading,
        downloadingFormat = _useCompetitorsList.downloadingFormat,
        fetchList = _useCompetitorsList.fetchList,
        loadFilterOptions = _useCompetitorsList.loadFilterOptions,
        loadMoreOptions = _useCompetitorsList.loadMoreOptions,
        searchOptions = _useCompetitorsList.searchOptions,
        setFilter = _useCompetitorsList.setFilter,
        resetFilters = _useCompetitorsList.resetFilters,
        setPage = _useCompetitorsList.setPage,
        downloadFile = _useCompetitorsList.downloadFile;

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(function () {
      fetchList();
    });
    return {
      competitors: competitors,
      meta: meta,
      filters: filters,
      filterOptions: filterOptions,
      filterLoading: filterLoading,
      filterLoadingMore: filterLoadingMore,
      loading: loading,
      downloadingFormat: downloadingFormat,
      loadFilterOptions: loadFilterOptions,
      loadMoreOptions: loadMoreOptions,
      searchOptions: searchOptions,
      setFilter: setFilter,
      resetFilters: resetFilters,
      setPage: setPage,
      downloadFile: downloadFile
    };
  }
}));

/***/ }),

/***/ 1456:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1457);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("ffd1162a", content, true, {});

/***/ }),

/***/ 1457:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".competitors-results[data-v-bdbfb0b2]{position:relative}.competitors-results--loading>.competitors-table[data-v-bdbfb0b2],.competitors-results--loading>.pagination-container[data-v-bdbfb0b2]{opacity:.5;pointer-events:none}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/views/Competitors/CompetitorsList.vue"],"names":[],"mappings":"AACA,sCACE,iBAAmB,CACpB,AACD,uIAEE,WAAa,AACb,mBAAqB,CACtB","file":"CompetitorsList.vue","sourcesContent":["\n.competitors-results[data-v-bdbfb0b2] {\n  position: relative;\n}\n.competitors-results--loading > .competitors-table[data-v-bdbfb0b2],\n.competitors-results--loading > .pagination-container[data-v-bdbfb0b2] {\n  opacity: 0.5;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1458:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useCompetitorsList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_competitors__ = __webpack_require__(1459);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }


 // Filters whose option lists are small (single/double digits per committee) — loaded in full,
// no pagination, but drafts/events are re-fetched whenever year/draft_id changes (cascade).

var SIMPLE_FILTER_KEYS = ['nomination_status', 'years', 'drafts', 'events']; // Filters with hundreds-thousands of options per committee — cursor-paginated + server search.

var CURSOR_FILTER_KEYS = ['members', 'horses'];
function useCompetitorsList() {
  var _getCurrentInstance = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])(),
      proxy = _getCurrentInstance.proxy;

  var route = proxy.$route;
  var router = proxy.$router;
  var competitors = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var meta = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
  var filters = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])({
    competitor_id: route.query.competitor_id ? Number(route.query.competitor_id) : null,
    nomination_status: route.query.nomination_status || null,
    horse_id: route.query.horse_id ? Number(route.query.horse_id) : null,
    year: route.query.year ? Number(route.query.year) : null,
    draft_id: route.query.draft_id ? Number(route.query.draft_id) : null,
    event_id: route.query.event_id ? Number(route.query.event_id) : null,
    page: route.query.page ? Number(route.query.page) : 1
  });
  var filterOptions = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])({
    members: [],
    horses: [],
    nomination_status: [],
    years: [],
    drafts: [],
    events: []
  });
  var filterLoading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])({
    members: false,
    horses: false,
    nomination_status: false,
    years: false,
    drafts: false,
    events: false
  });
  var filterLoadingMore = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])({
    members: false,
    horses: false
  });
  var filtersLoaded = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])({
    nomination_status: false,
    years: false
  }); // Cursor state kept per cursor-paginated filter: current search term + next page cursor.

  var cursorState = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])({
    members: {
      search: '',
      nextCursor: null
    },
    horses: {
      search: '',
      nextCursor: null
    }
  });
  var loading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

  function syncQueryParams() {
    var query = {};
    if (filters.value.competitor_id) query.competitor_id = String(filters.value.competitor_id);
    if (filters.value.nomination_status) query.nomination_status = filters.value.nomination_status;
    if (filters.value.horse_id) query.horse_id = String(filters.value.horse_id);
    if (filters.value.year) query.year = String(filters.value.year);
    if (filters.value.draft_id) query.draft_id = String(filters.value.draft_id);
    if (filters.value.event_id) query.event_id = String(filters.value.event_id);
    if (filters.value.page > 1) query.page = String(filters.value.page);
    router.replace({
      query: query
    }).catch(function () {});
  }

  function buildFilterParams() {
    var params = {};
    if (filters.value.competitor_id) params.competitor_id = filters.value.competitor_id;
    if (filters.value.nomination_status) params.nomination_status = filters.value.nomination_status;
    if (filters.value.horse_id) params.horse_id = filters.value.horse_id;
    if (filters.value.year) params.year = filters.value.year;
    if (filters.value.draft_id) params.draft_id = filters.value.draft_id;
    if (filters.value.event_id) params.event_id = filters.value.event_id;
    return params;
  }

  function fetchList() {
    return _fetchList.apply(this, arguments);
  } // Small unpaginated lists: nomination_status/years load once, drafts/events reload on cascade.


  function _fetchList() {
    _fetchList = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var params, res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.prev = 1;
              params = buildFilterParams();
              if (filters.value.page > 1) params.page = filters.value.page;
              _context.next = 6;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_competitors__["a" /* default */].getList(params);

            case 6:
              res = _context.sent;
              competitors.value = res.data.data;
              meta.value = res.data.meta != null ? res.data.meta : null;
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);
              competitors.value = [];

            case 14:
              _context.prev = 14;
              loading.value = false;
              return _context.finish(14);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 11, 14, 17]]);
    }));
    return _fetchList.apply(this, arguments);
  }

  function loadSimpleFilter(_x) {
    return _loadSimpleFilter.apply(this, arguments);
  } // Cursor-paginated members/horses: reset=true starts a fresh search from page 1.


  function _loadSimpleFilter() {
    _loadSimpleFilter = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(filterKey) {
      var params, res;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(filterKey === 'nomination_status' || filterKey === 'years')) {
                _context2.next = 3;
                break;
              }

              if (!filtersLoaded.value[filterKey]) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return");

            case 3:
              filterLoading.value[filterKey] = true;
              _context2.prev = 4;
              params = {
                type: filterKey
              };
              if (filterKey === 'drafts' && filters.value.year) params.year = filters.value.year;

              if (filterKey === 'events') {
                if (filters.value.draft_id) params.draft_id = filters.value.draft_id;else if (filters.value.year) params.year = filters.value.year;
              }

              _context2.next = 10;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_competitors__["a" /* default */].getFilters(params);

            case 10:
              res = _context2.sent;
              filterOptions.value[filterKey] = res.data.data[filterKey];
              if (filterKey === 'nomination_status' || filterKey === 'years') filtersLoaded.value[filterKey] = true;
              _context2.next = 17;
              break;

            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](4);

            case 17:
              _context2.prev = 17;
              filterLoading.value[filterKey] = false;
              return _context2.finish(17);

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[4, 15, 17, 20]]);
    }));
    return _loadSimpleFilter.apply(this, arguments);
  }

  function loadCursorFilter(_x2) {
    return _loadCursorFilter.apply(this, arguments);
  }

  function _loadCursorFilter() {
    _loadCursorFilter = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(filterKey) {
      var _ref,
          _ref$reset,
          reset,
          params,
          res,
          _args3 = arguments;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _ref = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {}, _ref$reset = _ref.reset, reset = _ref$reset === void 0 ? false : _ref$reset;

              if (!reset) {
                _context3.next = 6;
                break;
              }

              cursorState.value[filterKey] = {
                search: cursorState.value[filterKey].search,
                nextCursor: null
              };
              filterOptions.value[filterKey] = [];
              _context3.next = 8;
              break;

            case 6:
              if (!filterOptions.value[filterKey].length) {
                _context3.next = 8;
                break;
              }

              return _context3.abrupt("return");

            case 8:
              filterLoading.value[filterKey] = true;
              _context3.prev = 9;
              params = {
                type: filterKey,
                per_page: 10
              };
              if (cursorState.value[filterKey].search) params.search = cursorState.value[filterKey].search;
              _context3.next = 14;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_competitors__["a" /* default */].getFilters(params);

            case 14:
              res = _context3.sent;
              filterOptions.value[filterKey] = res.data.data[filterKey];
              cursorState.value[filterKey].nextCursor = res.data.data.next_cursor;
              _context3.next = 22;
              break;

            case 19:
              _context3.prev = 19;
              _context3.t0 = _context3["catch"](9);
              filterOptions.value[filterKey] = [];

            case 22:
              _context3.prev = 22;
              filterLoading.value[filterKey] = false;
              return _context3.finish(22);

            case 25:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[9, 19, 22, 25]]);
    }));
    return _loadCursorFilter.apply(this, arguments);
  }

  function loadMoreOptions(_x3) {
    return _loadMoreOptions.apply(this, arguments);
  }

  function _loadMoreOptions() {
    _loadMoreOptions = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee4(filterKey) {
      var state, params, res;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (CURSOR_FILTER_KEYS.includes(filterKey)) {
                _context4.next = 2;
                break;
              }

              return _context4.abrupt("return");

            case 2:
              state = cursorState.value[filterKey];

              if (!(!state.nextCursor || filterLoadingMore.value[filterKey] || filterLoading.value[filterKey])) {
                _context4.next = 5;
                break;
              }

              return _context4.abrupt("return");

            case 5:
              filterLoadingMore.value[filterKey] = true;
              _context4.prev = 6;
              params = {
                type: filterKey,
                per_page: 10,
                cursor: state.nextCursor
              };
              if (state.search) params.search = state.search;
              _context4.next = 11;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_competitors__["a" /* default */].getFilters(params);

            case 11:
              res = _context4.sent;
              filterOptions.value[filterKey] = [].concat(_toConsumableArray(filterOptions.value[filterKey]), _toConsumableArray(res.data.data[filterKey]));
              state.nextCursor = res.data.data.next_cursor;
              _context4.next = 18;
              break;

            case 16:
              _context4.prev = 16;
              _context4.t0 = _context4["catch"](6);

            case 18:
              _context4.prev = 18;
              filterLoadingMore.value[filterKey] = false;
              return _context4.finish(18);

            case 21:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[6, 16, 18, 21]]);
    }));
    return _loadMoreOptions.apply(this, arguments);
  }

  function searchOptions(_x4, _x5) {
    return _searchOptions.apply(this, arguments);
  }

  function _searchOptions() {
    _searchOptions = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee5(filterKey, query) {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (CURSOR_FILTER_KEYS.includes(filterKey)) {
                _context5.next = 2;
                break;
              }

              return _context5.abrupt("return");

            case 2:
              cursorState.value[filterKey].search = query;
              _context5.next = 5;
              return loadCursorFilter(filterKey, {
                reset: true
              });

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    return _searchOptions.apply(this, arguments);
  }

  function loadFilterOptions(_x6) {
    return _loadFilterOptions.apply(this, arguments);
  }

  function _loadFilterOptions() {
    _loadFilterOptions = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee6(filterKey) {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!CURSOR_FILTER_KEYS.includes(filterKey)) {
                _context6.next = 4;
                break;
              }

              _context6.next = 3;
              return loadCursorFilter(filterKey, {
                reset: !filterOptions.value[filterKey].length
              });

            case 3:
              return _context6.abrupt("return");

            case 4:
              if (!SIMPLE_FILTER_KEYS.includes(filterKey)) {
                _context6.next = 7;
                break;
              }

              _context6.next = 7;
              return loadSimpleFilter(filterKey);

            case 7:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
    return _loadFilterOptions.apply(this, arguments);
  }

  function setFilter(key, val) {
    filters.value[key] = val;
    filters.value.page = 1;

    if (key === 'year') {
      filters.value.draft_id = null;
      filters.value.event_id = null;
      filtersLoaded.value.drafts = false;
      loadSimpleFilter('drafts');
      loadSimpleFilter('events');
    }

    if (key === 'draft_id') {
      filters.value.event_id = null;
      loadSimpleFilter('events');
    }

    syncQueryParams();
    fetchList();
  }

  function resetFilters() {
    filters.value = {
      competitor_id: null,
      nomination_status: null,
      horse_id: null,
      year: null,
      draft_id: null,
      event_id: null,
      page: 1
    };
    loadSimpleFilter('drafts');
    loadSimpleFilter('events');
    syncQueryParams();
    fetchList();
  }

  function setPage(page) {
    filters.value.page = page;
    syncQueryParams();
    fetchList();
  }

  var downloadingFormat = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);

  function downloadFile(_x7) {
    return _downloadFile.apply(this, arguments);
  }

  function _downloadFile() {
    _downloadFile = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee7(format) {
      var params, response, blobUrl, url, link;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (!(downloadingFormat.value != null)) {
                _context7.next = 2;
                break;
              }

              return _context7.abrupt("return");

            case 2:
              downloadingFormat.value = format;
              _context7.prev = 3;
              params = buildFilterParams();
              params.format = format;
              _context7.next = 8;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_competitors__["a" /* default */].exportFile(params);

            case 8:
              response = _context7.sent;

              if (!(format === 'pdf')) {
                _context7.next = 13;
                break;
              }

              blobUrl = URL.createObjectURL(new Blob([response.data], {
                type: 'application/pdf'
              }));
              window.open(blobUrl, '_blank');
              return _context7.abrupt("return");

            case 13:
              url = URL.createObjectURL(new Blob([response.data]));
              link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'competitors.xlsx');
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              URL.revokeObjectURL(url);

            case 21:
              _context7.prev = 21;
              downloadingFormat.value = null;
              return _context7.finish(21);

            case 24:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[3,, 21, 24]]);
    }));
    return _downloadFile.apply(this, arguments);
  }

  return {
    competitors: competitors,
    meta: meta,
    filters: filters,
    filterOptions: filterOptions,
    filterLoading: filterLoading,
    filterLoadingMore: filterLoadingMore,
    loading: loading,
    downloadingFormat: downloadingFormat,
    fetchList: fetchList,
    loadFilterOptions: loadFilterOptions,
    loadMoreOptions: loadMoreOptions,
    searchOptions: searchOptions,
    setFilter: setFilter,
    resetFilters: resetFilters,
    setPage: setPage,
    downloadFile: downloadFile
  };
}

/***/ }),

/***/ 1459:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(26);

/* harmony default export */ __webpack_exports__["a"] = ({
  getList: function getList(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/competitors', {
      params: params
    });
  },
  getFilters: function getFilters(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/competitors/filters', {
      params: params
    });
  },
  exportFile: function exportFile(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/competitors/export', {
      params: params,
      responseType: 'blob'
    });
  }
});

/***/ }),

/***/ 1460:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"full-width":true}},[_c('div',{staticClass:"bg-white rounded mb-4 p-3",attrs:{"slot":"tabContent"},slot:"tabContent"},[_c('page-heading',[_vm._v("Competitors")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center mb-3"},[_c('app-button',{staticClass:"mr-2",attrs:{"variant":"outline-primary","size":"sm","block":false,"loading":_vm.downloadingFormat === 'pdf',"disabled":_vm.downloadingFormat != null},on:{"click":function($event){return _vm.downloadFile('pdf')}}},[_vm._v("\n        Download PDF\n      ")]),_vm._v(" "),_c('app-button',{staticClass:"mr-2",attrs:{"variant":"outline-primary","size":"sm","block":false,"loading":_vm.downloadingFormat === 'xlsx',"disabled":_vm.downloadingFormat != null},on:{"click":function($event){return _vm.downloadFile('xlsx')}}},[_vm._v("\n        Download CSV\n      ")]),_vm._v(" "),_c('app-button',{attrs:{"variant":"outline-secondary","size":"sm","block":false},on:{"click":_vm.resetFilters}},[_vm._v("\n        Reset filters\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"competitors-results",class:{ 'competitors-results--loading': _vm.loading }},[(_vm.loading)?_c('div',{staticClass:"table-overlay"},[_c('div',{staticClass:"table-spinner"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"competitors-table",staticStyle:{"min-height":"400px","font-size":"1.125rem"}},[_c('table',{staticClass:"table table-sm table-borderless mb-0"},[_c('thead',[_c('tr',[_c('th',[_c('div',{staticClass:"font-weight-bold mb-1"},[_vm._v("Competitor")]),_vm._v(" "),_c('f-search-select',{attrs:{"id":"filter_competitor","options":_vm.filterOptions.members,"value":_vm.filters.competitor_id,"loading":_vm.filterLoading.members,"loading-more":_vm.filterLoadingMore.members,"placeholder":"Select competitor"},on:{"open":function($event){return _vm.loadFilterOptions('members')},"search-change":function($event){return _vm.searchOptions('members', $event)},"load-more":function($event){return _vm.loadMoreOptions('members')},"input":function($event){return _vm.setFilter('competitor_id', $event)}}})],1),_vm._v(" "),_c('th',[_c('div',{staticClass:"font-weight-bold mb-1"},[_vm._v("Nomination Status")]),_vm._v(" "),_c('f-search-select',{attrs:{"id":"filter_nomination_status","options":_vm.filterOptions.nomination_status,"value":_vm.filters.nomination_status,"loading":_vm.filterLoading.nomination_status,"placeholder":"Select status"},on:{"open":function($event){return _vm.loadFilterOptions('nomination_status')},"input":function($event){return _vm.setFilter('nomination_status', $event)}}})],1),_vm._v(" "),_c('th',[_c('div',{staticClass:"font-weight-bold mb-1"},[_vm._v("Horse")]),_vm._v(" "),_c('f-search-select',{attrs:{"id":"filter_horse","options":_vm.filterOptions.horses,"value":_vm.filters.horse_id,"loading":_vm.filterLoading.horses,"loading-more":_vm.filterLoadingMore.horses,"placeholder":"Select horse"},on:{"open":function($event){return _vm.loadFilterOptions('horses')},"search-change":function($event){return _vm.searchOptions('horses', $event)},"load-more":function($event){return _vm.loadMoreOptions('horses')},"input":function($event){return _vm.setFilter('horse_id', $event)}}})],1),_vm._v(" "),_c('th',[_c('div',{staticClass:"font-weight-bold mb-1"},[_vm._v("Year")]),_vm._v(" "),_c('f-search-select',{attrs:{"id":"filter_year","options":_vm.filterOptions.years,"value":_vm.filters.year,"loading":_vm.filterLoading.years,"placeholder":"Select year"},on:{"open":function($event){return _vm.loadFilterOptions('years')},"input":function($event){return _vm.setFilter('year', $event)}}})],1),_vm._v(" "),_c('th',[_c('div',{staticClass:"font-weight-bold mb-1"},[_vm._v("Draft")]),_vm._v(" "),_c('f-search-select',{attrs:{"id":"filter_draft","options":_vm.filterOptions.drafts,"value":_vm.filters.draft_id,"loading":_vm.filterLoading.drafts,"placeholder":"Select draft"},on:{"open":function($event){return _vm.loadFilterOptions('drafts')},"input":function($event){return _vm.setFilter('draft_id', $event)}}})],1),_vm._v(" "),_c('th',[_c('div',{staticClass:"font-weight-bold mb-1"},[_vm._v("Event")]),_vm._v(" "),_c('f-search-select',{attrs:{"id":"filter_event","options":_vm.filterOptions.events,"value":_vm.filters.event_id,"loading":_vm.filterLoading.events,"placeholder":"Select event"},on:{"open":function($event){return _vm.loadFilterOptions('events')},"input":function($event){return _vm.setFilter('event_id', $event)}}})],1)])]),_vm._v(" "),(_vm.competitors.length)?_c('tbody',_vm._l((_vm.competitors),function(row){return _c('tr',{key:row.id},[_c('td',{staticClass:"font-weight-bold"},[_vm._v("\n              "+_vm._s(row.competitor_name)+"\n              "),(row.competitor_deleted)?_c('small',{staticClass:"text-primary ml-1"},[_vm._v("(deleted)")]):_vm._e(),_vm._v(" "),(row.competitor_town)?_c('span',[_vm._v(" from "+_vm._s(row.competitor_town))]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.nomination_status_label))]),_vm._v(" "),_c('td',[_vm._v("\n              "+_vm._s(row.horse_name)+"\n              "),(row.horse_deleted)?_c('small',{staticClass:"text-primary ml-1"},[_vm._v("(deleted)")]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.draft_year))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.draft_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.event_name))])])}),0):(!_vm.loading)?_c('tbody',[_c('tr',[_c('td',{attrs:{"colspan":"6"}},[_vm._v("No competitors found.")])])]):_vm._e()])]),_vm._v(" "),(_vm.meta != null)?_c('pagination',{staticClass:"mt-3",attrs:{"total-pages":_vm.meta.last_page,"page":_vm.meta.current_page,"on-change":_vm.setPage,"disabled":_vm.loading}}):_vm._e()],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/26.dbfd5aecdbd711582ac2.js